import { Component } from '@angular/core';

@Component({
  selector: 'app-shipping-policy',
  templateUrl: './shipping-policy.component.html',
  styleUrls: ['./shipping-policy.component.css'],
  standalone: false
})
export class ShippingPolicyComponent {}
